import { render, staticRenderFns } from "./ShotValGameInfo.vue?vue&type=template&id=a8c42b28&"
import script from "./ShotValGameInfo.vue?vue&type=script&lang=js&"
export * from "./ShotValGameInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShotValGameInfo.vue?vue&type=style&index=0&id=a8c42b28&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports